import React from 'react';
import i18n from '../../../../../../utils/i18n';

import LanguageCheckOn from '../../../../../../images/LanguageIcons/language-check-on.svg';
import LanguageCheckOff from '../../../../../../images/LanguageIcons/language-check-off.svg';
import { Checkbox, TextField } from '@mui/material';
import TextfieldUnit from '../../../../../components/TextfieldUnit';

const InsuranceInfo = ({
	service = '',
	insuredAmount,
	expiryDate = '----.--.--',
	isSelected = false,
	onSelect = () => {},
	onSelectValue = () => {},
	onSelectExpiration = () => {},
}) => {
	const isMobile = window.innerWidth < 480;
	return (
		<div
			style={{
				display: 'flex',
				flexDirection: isMobile ? 'column' : 'row',
				justifyContent: 'space-between',
				alignItems: isMobile ? 'flex-start' : 'stretch',
				padding: '16px',
				borderRadius: '12px',
				backgroundColor: '#ffffff',
				border: '1px solid #e3e5e9',
				width: '100%',
				minHeight: isMobile ? 'auto' : '80px',
				margin: '8px 0',
				gap: isMobile ? '16px' : '24px',
			}}>
			{/* Service Column */}
			<div
				style={{
					display: 'flex',
					flexDirection: 'row',
					flex: isMobile ? 'none' : '1',
					justifyContent: 'flex-start',
					alignItems: 'center',
					cursor: 'pointer',
					minWidth: isMobile ? '100%' : '200px',
					height: '100%',
				}}
				onClick={onSelect}>
				<div
					style={{
						backgroundColor: '#fafcfe',
						display: 'flex',
						padding: '4px',
						alignItems: 'center',
						cursor: 'pointer',
						borderRadius: '4px',
						marginRight: '12px',
						height: '20px',
					}}>
					<Checkbox
						checked={isSelected}
						onChange={onSelect}
						icon={
							<img
								src={LanguageCheckOff}
								alt={i18n.t('general.uncheckedIcon')}
								style={{
									width: '16px',
									height: '16px',
									cursor: 'pointer',
								}}
							/>
						}
						checkedIcon={
							<img
								src={LanguageCheckOn}
								alt={i18n.t('general.checkedIcon')}
								style={{
									width: '16px',
									height: '16px',
									cursor: 'pointer',
								}}
							/>
						}
						style={{
							padding: 0,
							cursor: 'pointer',
						}}
						onClick={(e) => e.stopPropagation()}
					/>
				</div>

				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						flex: 1,
						justifyContent: 'center',
						alignItems: 'flex-start',
						height: '100%',
						paddingTop: '8px',
						paddingBottom: '8px',
					}}>
					<div
						style={{
							fontSize: '12px',
							color: '#8791b4',
							fontWeight: '500',
							marginBottom: '4px',
						}}>
						{i18n.t('provider.service')}
					</div>
					<div
						style={{
							fontSize: '14px',
							color: '#4b5080',
							fontWeight: '700',
							lineHeight: '1.4',
						}}>
						{service}
					</div>
				</div>
			</div>

			{/* Amount Column */}
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					flex: isMobile ? 'none' : '1',
					justifyContent: 'flex-start',
					alignItems: 'flex-start',
					minWidth: isMobile ? '100%' : '180px',
				}}>
				<div
					style={{
						fontSize: '12px',
						color: '#8791b4',
						fontWeight: '500',
						marginBottom: '8px',
					}}>
					{i18n.t('provider.insuredamount')}
				</div>
				<TextfieldUnit
					id="insuredAmount"
					placeholder={i18n.t('provider.enteramount')}
					value={insuredAmount}
					onChange={(e) => {
						let value = e.target.value;
						console.log('Value:', value);
						if (value.length > 1 && value.startsWith('0')) {
							value = value.replace(/^0/, '');
						}
						onSelectValue(value);
					}}
					unit={i18n.t('general.currency')}
				/>
			</div>

			{/* Date Column */}
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					flex: isMobile ? 'none' : '1',
					justifyContent: 'flex-start',
					alignItems: 'flex-start',
					minWidth: isMobile ? '100%' : '160px',
				}}>
				<div
					style={{
						fontSize: '12px',
						color: '#8791b4',
						fontWeight: '500',
						marginBottom: '8px',
					}}>
					{i18n.t('provider.expirydate')}
				</div>
				<TextField
					value={expiryDate}
					onChange={(e) => onSelectExpiration(e.target.value)}
					variant="outlined"
					size="small"
					type="date"
					sx={{
						width: '100%',
						fontSize: '14px',
						'& .MuiOutlinedInput-root': {
							borderRadius: '8px',
							height: '45px',
						},
					}}
				/>
			</div>
			{/* <div style={{ display: 'flex' }}>
                <div style={{ paddingRight: '14px' }}>
                    <IconButton
                        style={{
                            padding: '8px',
                            color: '#4b5080',
                        }}
                    >
                    </IconButton>
                </div>

                <div style={{ borderLeft: '1px solid #e3e5e9', paddingLeft: '14px' }}>
                    <IconButton
                        style={{
                            padding: '8px',
                            color: '#4b5080',
                        }}
                    >
                        <img
                            src={IconTrashGrey}
                            alt='Delete'
                            style={{ width: '14px', height: '14px' }}
                        />
                    </IconButton>
                </div>
            </div> */}
		</div>
	);
};

export default InsuranceInfo;
